"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Typeahead = void 0;
const downshift_1 = __importDefault(require("downshift"));
const react_1 = __importDefault(require("react"));
const design_system_1 = require("@zapier/design-system");
const common_utils_1 = require("@zapier/common-utils");
const TypeaheadInput_1 = require("./TypeaheadInput");
const defaultFilterItems = (inputValue, items, getLabelForItem, showEmptyList = false) => {
    if (showEmptyList || !inputValue) {
        return items;
    }
    const lowerCaseInput = inputValue.toLowerCase();
    return items.filter(item => getLabelForItem(item).toLowerCase().includes(lowerCaseInput));
};
const Styles = common_utils_1.labelStyles(__filename, {
    root: () => [
        {
            position: 'relative',
        },
    ],
});
class Typeahead extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasInputChanged: false,
        };
        this.itemToString = (item) => {
            return item ? this.props.getLabelForItem(item) : '';
        };
        this.stateReducer = (state, changes) => {
            if (this.props.keepInputValueOnBlur &&
                (changes.type === downshift_1.default.stateChangeTypes.blurInput ||
                    changes.type === downshift_1.default.stateChangeTypes.mouseUp)) {
                return Object.assign(Object.assign({}, changes), { inputValue: state.inputValue });
            }
            return changes;
        };
        this.onInputChange = (_e) => {
            this.setState({ hasInputChanged: true });
        };
        this.searchInput = react_1.default.createRef();
    }
    render() {
        const { props } = this;
        return (common_utils_1.isolateComponent(downshift_1.default, { id: props.id, initialSelectedItem: props.selectedItem || props.initialSelectedItem, inputId: props.inputId, inputValue: props.inputValue, itemToString: this.itemToString, labelId: props.labelId, onChange: selectedItem => {
                const eventLocation = this.searchInput.current
                    ? 'search_results'
                    : 'direct_dropdown';
                props.onChange(selectedItem, eventLocation);
                this.searchInput.current = '';
            }, onInputValueChange: props.onInputValueChange, selectedItem: props.selectedItem, stateReducer: this.stateReducer }, ({ clearSelection, getInputProps, getItemProps, getMenuProps, highlightedIndex, inputId, inputValue, isOpen, openMenu, selectedItem, }) => {
            if (props.setClearSelection) {
                props.setClearSelection(clearSelection);
            }
            const onFocusInput = props.openOnFocus
                ? () => {
                    this.setState({ hasInputChanged: false });
                    openMenu();
                }
                : undefined;
            const { onChange } = getInputProps();
            const onInputChange = (e) => {
                this.searchInput.current = e.target.value;
                this.onInputChange(e);
                onChange(e);
            };
            const filteredItems = props.filterItems(inputValue, props.items, props.getLabelForItem, props.showEmptyList || false);
            const itemsToRender = this.state.hasInputChanged
                ? filteredItems
                : props.items;
            const showMenu = isOpen && filteredItems.length > 0;
            const isErrored = (props.showErrorOnNoResults &&
                inputValue &&
                filteredItems.length === 0) ||
                props.isErrored;
            const ariaLabelledBy = props.labelId || null;
            return (common_utils_1.isolateComponent("div", null,
                common_utils_1.isolateComponent("div", { css: Styles.root() },
                    common_utils_1.isolateComponent(TypeaheadInput_1.TypeaheadInput, { ariaLabel: props.ariaLabel, ariaLabelledBy: ariaLabelledBy, autoComplete: props.autoComplete, clearSelection: clearSelection, disabledText: props.disabledText, getInputProps: getInputProps, getLabelForItem: props.getLabelForItem, iconEndName: props.iconEndName, inputValue: inputValue, isBusy: props.isBusy, isDisabled: props.isDisabled, isErrored: !!isErrored, isMenuOpen: showMenu, onChange: onInputChange, onFocus: onFocusInput, placeholder: props.placeholder, renderIcon: props.renderIcon, selectedItem: selectedItem, size: props.size }),
                    showMenu &&
                        props.renderFloatingMenu({
                            ariaLabel: props.menuAriaLabel,
                            getItemProps,
                            getKeyForItem: props.getKeyForItem,
                            getLabelForItem: props.getLabelForItem,
                            getMenuProps,
                            highlightedIndex,
                            items: itemsToRender,
                            renderIcon: props.renderIcon,
                            selectedItem,
                        }))));
        }));
    }
}
exports.Typeahead = Typeahead;
Typeahead.defaultProps = {
    filterItems: defaultFilterItems,
    isDisabled: false,
    openOnFocus: false,
    renderFloatingMenu: (props) => (common_utils_1.isolateComponent(design_system_1.FloatingMenu, Object.assign({}, props))),
    showEmptyList: false,
    showErrorOnNoResults: false,
};
